module.exports = __webpack_public_path__ + "img/108.27d194e5.jpg";